import styled from "styled-components";

import { Default } from "Types";
import { Molecules } from "Types/Components";

import AtomLabel from "Components/Atoms/Label";
import AtomSelect from "Components/Atoms/Select";

export type PropsType = Molecules.FormText;

const Wrap = styled.label<Default>`
   display: flex;
   flex-direction: column;
   row-gap: 10px;
   margin-top: 25px;
   ${({ css }) => css}
`;

export default function MoleculeSelect(props: PropsType) {
   return (
      <Wrap {...props}>
         <AtomLabel></AtomLabel>
         <AtomSelect></AtomSelect>
      </Wrap>
   );
}

MoleculeSelect.Wrap = Wrap;
MoleculeSelect.Label = AtomLabel;
MoleculeSelect.Select = AtomSelect;
